import React from 'react'
import { LoadingOverlay, LoadingContent, Spinner } from './style'

const GlobalLoadingOverlay: React.FC = () => {
  return (
    <LoadingOverlay>
      <LoadingContent>
        <Spinner />
      </LoadingContent>
    </LoadingOverlay>
  )
}

export default GlobalLoadingOverlay
